import React from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'

const openStripePortal = async (userId) => {
  try {
    const baseUrl = process.env.CORPORATE_URL.replace(/\/$/, '')
    const endpointUrl = `${baseUrl}/api/users/generate-portal-link/${userId}`

    const res = await fetch(endpointUrl, {
      method: 'GET',
      credentials: 'include',
    })

    if (!res.ok) {
      const text = await res.text()
      console.warn('Stripe portal HTTP error', res.status, text)
      throw new Error(`HTTP ${res.status}`)
    }

    const response = await res.json()

    if (
      Object.prototype.hasOwnProperty.call(response, 'success') &&
      response.success === false
    ) {
      throw new Error(response.message || 'Something went wrong')
    }

    if (!response.url) {
      throw new Error('Stripe portal URL missing in response')
    }

    window.open(response.url, '_self')
  } catch (err) {
    console.warn('Error opening Stripe portal', err)
  }
}

const AccountMenuItems = ({ t, uiStore, onLogout }) => {
  const handleLogOut = () => {
    localStorage.removeItem('leftDrawerSortType')
    onLogout({
      logoutParams: {
        returnTo: process.env.CORPORATE_URL
      }
    })
  }
  const roleLabelMap = {
    starter: t('GLOBAL.ACC_STARTER'),
    standalone: t('GLOBAL.ACC_SOLO'),
    enterprise_manager: t('GLOBAL.ACC_ENTERPRISE'),
    enterprise_developer: t('GLOBAL.ACC_ENTERPRISE'),
  }

  return (
    <>
      <span className='toolbar__user' onClick={(e) => { e.stopPropagation() }}>{uiStore.user.email}</span>
      <a
        className='toolbar__sublist-btn toolbar__sublist-btn--account'
        href='#'
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          openStripePortal(uiStore.user.id)
        }}
      >
        {t('TOOLBAR.ACCOUNT')}
        <span
          className={`toolbar__user-type toolbar__user-type--${uiStore.user.type}`}
        >
          {roleLabelMap[uiStore.user.type]
            ? roleLabelMap[uiStore.user.type]
            : t('GLOBAL.ACCOUNT')}
        </span>
      </a>
      <button type='button' className='toolbar__sublist-btn' onClick={handleLogOut}>
        {t('GLOBAL.LOG_OUT')}
      </button>
    </>
  )
}

export default withTranslation()(inject('uiStore')(observer(AccountMenuItems)))
